/* External dependencies */
import { Action } from 'redux';
import get from 'lodash/get';

/* Internal dependencies */
import { generateActionCreator } from '../helpers/duckGenerators';
import { ApplicationState } from '..';
import { User } from '../../types/User';
import Community from '../../types/Community';
import Artist from '../../types/Artist';

enum PreviousProfileActionType {
  UPDATE_PREVIOUS_PROFILE = 'reducer/previousProfile/UPDATE_PREVIOUS_PROFILE',
  RESET_PREVIOUS_PROFILE = 'reducer/previousProfile/RESET_PREVIOUS_PROFILE',
}

export type Profile = User | Community | Artist

export type PreviousProfileState = Profile | null;

/* Selectors */
export const getPreviousProfile = (state: ApplicationState) => state.previousProfile;

/* Action creators */
export const updatePreviousProfile = generateActionCreator<PreviousProfileActionType.UPDATE_PREVIOUS_PROFILE, PreviousProfileState>(
  PreviousProfileActionType.UPDATE_PREVIOUS_PROFILE
);

export const resetPreviousProfile = generateActionCreator<PreviousProfileActionType.RESET_PREVIOUS_PROFILE, PreviousProfileState>(
  PreviousProfileActionType.RESET_PREVIOUS_PROFILE
);

export const INITIAL_STATE = null;

/* Reducer */
const previousProfileReducer = (
  state: PreviousProfileState = INITIAL_STATE,
  action: Action & { payload: Profile }
): PreviousProfileState => {
  const { payload } = action;
  if (action.type === PreviousProfileActionType.UPDATE_PREVIOUS_PROFILE) {
    return {
      ...payload,
    };
  }

  if (action.type === PreviousProfileActionType.RESET_PREVIOUS_PROFILE) {
    return {
      location: get(state, 'location'), // TODO: to avoid issue with "undefined" being an invalid coordinate. Should truthy check wherever this error is thrown
    } as PreviousProfileState;
  }

  return state;
};

export default previousProfileReducer;
